import { Box, Drawer } from '@mui/material';
import { ReactNode, useEffect, useState } from 'react';

interface LeftDrawerProps {
  drawerContent: ReactNode;
  children: ReactNode;
  drawerWidth?: number;
}

export const LeftDrawer = ({
  drawerContent,
  children,
  drawerWidth = 256,
}: LeftDrawerProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  useEffect(() => {
    setIsDrawerOpen(true);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        width: '100%',
      }}
    >
      <Box
        sx={{
          width: { xs: '100%', sm: `${drawerWidth}px` },
          flexShrink: 0,
          overflowY: 'auto',
          borderLeft: 1,
          borderColor: 'divider',
        }}
      >
        <Drawer
          variant="persistent"
          anchor="left"
          open={isDrawerOpen}
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            height: '100%',
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              height: '100%',
              boxSizing: 'border-box',
              boxShadow: 'none',
              borderRight: '1px solid rgba(0, 0, 0, 0.12)',
              position: 'relative',
              marginLeft: 0,
              top: 0,
            },
          }}
        >
          {drawerContent}
        </Drawer>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          width: '100%',
          height: '100%',
          overflowY: 'auto',
          boxSizing: 'border-box',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
